import {
    AUTH_USER_ERROR_HANDLED,
    AUTH_USER,
    UNAUTH_USER,
    AUTH_ERROR,
    AUTH_PENDING,
    REFRESH_USER,
    REFRESH_PENDING,
    REFRESH_ERROR,
    FORGOT_PASSWORD_EMAIL_SENT,
    EDITING_USER
} from './types';
import {LOGIN} from "../../constants/routes";

export const INITIAL_STATE = {
    error: null,
    content: {},
    pending: false,
    authenticated: false,
    sending: false,
    email: false,
    previousPathname: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FORGOT_PASSWORD_EMAIL_SENT:
            return {
                ...state,
                error: null,
                pending: false,
                authenticated: false,
                sending: false,
                email: true
            };
        case AUTH_USER_ERROR_HANDLED:
            return {
                ...state,
                error: null
            };
        case AUTH_PENDING:
            return {
                ...state,
                authenticated: false,
                pending: true,
                email: false
            };
        case AUTH_USER:
            return {
                ...state,
                pending: false,
                sending: false,
                authenticated: true,
                content: action.payload,
                email: false
            };
        case UNAUTH_USER:
            return {
                ...state,
                pending: false,
                authenticated: false,
                email: false
            };
        case AUTH_ERROR:
            return {
                ...state,
                pending: false,
                authenticated: false,
                error: action.payload,
                email: false
            };
        case REFRESH_PENDING:
            let newPreviousPathname = (action.payload === LOGIN) ?
                state.previousPathname
                : action.payload;
            return {
                ...state,
                //authenticated: false,
                pending: true,
                email: false,
                previousPathname: newPreviousPathname
            };
        case REFRESH_USER:
            let newContent = {...state.content, ...action.payload};
            return {
                ...state,
                authenticated: true,
                pending: false,
                content: newContent,
                email: false
            };
        case REFRESH_ERROR:
            return {
                ...state,
                pending: false,
                authenticated: false,
                error: action.payload,
                email: false
            };
        case EDITING_USER:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/auth/reducers.js